import UserService from '../../../services/UserService';
import { useTranslation } from 'react-i18next';
import { getStatusTranslationKey } from '../DashboardUtilities';

const ExportMsgBtn = ({ messages, berichtDisplayFieldDict }) => {
    const { t } = useTranslation();

    const handleDownloadStringAsCsv = (str) => {
        const blob = new Blob([str], {
            type: "text/csv;charset=utf-8;"
        });

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "supplyDriveMsgExport.csv";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    }

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString('nl-NL');
    };

    const sanitizeCsvCell = (str) => {
        if (str === undefined || str === null || str === "null") str = "";
        return (str + "").replaceAll('\n', '').replaceAll('\r', '').replaceAll(';', ':');
    };

    // { id: "type", label: t('messageDownload.type'), sortFieldName: "type", active: true, employeeOnly: false, hasCopyBtn: false },
    const handleMakeCsvFromMessages = () => {
        var csvString = "";

        berichtDisplayFieldDict.forEach(dictEntry => {
            if (!dictEntry.active) return;
            else if (dictEntry.employeeOnly && (!UserService.hasRole(["Administrator", "SD_Medewerker"]))) return;
            csvString += sanitizeCsvCell(dictEntry.label) + ';';
        });
        csvString += '\n';

        messages.forEach(message => {
            berichtDisplayFieldDict.forEach(dictEntry => {
                if (!dictEntry.active) return;
                else if (dictEntry.employeeOnly && (!UserService.hasRole(["Administrator", "SD_Medewerker"]))) return;
                var value = dictEntry.id === "verzonden_datumtijd" || dictEntry.id === "ontvangen_datumtijd" ? formatDate(message[dictEntry.id]) : message[dictEntry.id];
                if (dictEntry.id === "status") {
                    var key = getStatusTranslationKey(message.status);
                    // For Klant users, show "delivered" for status 5 (manuallyProcessed)
                    if (message.status === "5" && UserService.hasRole(['Klant'])) {
                        key = 'delivered';
                    }
                    value = t(`messageStatuses.${key}`);
                }
                csvString += sanitizeCsvCell(value) + ';';
            });
            csvString += '\n';
        });
        handleDownloadStringAsCsv(csvString);
    };

    return (
    <div className="action-bar">
        <button
            className="btn btn-primary"
            onClick={handleMakeCsvFromMessages}
        >{t('common.export')}</button>
    </div>
    );
};
export default ExportMsgBtn;